import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stLedgerEntries } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingRedpacketLedgerEntries;

/** User-side ledger (scope=USER). Claim credits only (IN); OUT lives on withdrawals. */
export const redpacketLedgerEntriesDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const direction = 'IN';
    const userId = (params.filter?.userId as string | undefined) || undefined;
    const packetId = (params.filter?.packetId as string | undefined) || undefined;
    const roomId = (params.filter?.roomId as string | undefined) || undefined;
    const roomName = (params.filter?.roomName as string | undefined) || undefined;
    const nickname = (params.filter?.nickname as string | undefined) || undefined;
    const res = await stLedgerEntries({
      scope: 'USER',
      direction,
      userId,
      packetId,
      roomId,
      roomName,
      nickname,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
